import React from 'react';
import { Container, Typography, Box, Grid2 as Grid, Divider } from '@mui/material';
import Footer from "../layout/Footer";

const CondicionesUso = () => {
  return (
    <>
      {/* Hero Section */}
      <Box className="header-container">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container size={12} sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h1" component="h1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              OneService - Condiciones de Uso
            </Typography>
            <Typography variant="h3" component="h3" gutterBottom sx={{ color: 'white', textAlign: 'center' }}>
              Fecha de última actualización: {new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
            </Typography>
          </Grid>
        </Container>
      </Box >

      <Container maxWidth="md" sx={{ py: 6 }}>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            1. Aceptación
          </Typography>
          <Typography variant="body1" paragraph>
            El acceso y uso de la plataforma digital OneService (la "Plataforma") implica la aceptación plena y sin reservas de las presentes Condiciones de Uso.
            Si el usuario no acepta estos términos, deberá abstenerse de utilizar la Plataforma.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            2. Naturaleza del Servicio
          </Typography>
          <Typography variant="body1" paragraph>
            OneService es una plataforma tecnológica que actúa exclusivamente como intermediario digital entre:<br />
            · Usuarios solicitantes de servicios ("Clientes")<br />
            · Prestadores independientes ("Proveedores")
          </Typography>
          <Typography variant="body1" paragraph>
            OneService:<br />
            · No presta directamente los servicios anunciados.<br />
            · No actúa como empleador.<br />
            · No asume responsabilidad por la ejecución material del servicio.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            3. Registro y Responsabilidad del Usuario
          </Typography>
          <Typography variant="body1" paragraph>
            El usuario se obliga a:<br />
            · Proporcionar información veraz.<br />
            · Mantener actualizados sus datos.<br />
            · Proteger sus credenciales.<br />
            · No permitir el uso no autorizado de su cuenta.
          </Typography>
          <Typography variant="body1" paragraph>
            OneService podrá suspender o cancelar cuentas en caso de incumplimiento.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            4. Relación entre las Partes
          </Typography>
          <Typography variant="body1" paragraph>
            Los Proveedores actúan como prestadores de servicios independientes conforme a la legislación mexicana.
            No existe relación laboral, subordinación ni representación entre OneService y los Proveedores.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            5. Pagos y Comisiones
          </Typography>
          <Typography variant="body1" paragraph>
            Los pagos realizados a través de la Plataforma:<br />
            · Serán procesados por terceros autorizados.<br />
            · Podrán estar sujetos a comisión por intermediación.<br />
            · Se regirán por las políticas de cancelación vigentes.
          </Typography>
          <Typography variant="body1" paragraph>
            OneService no es entidad financiera ni custodio de fondos.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            6. Cancelaciones y Reembolsos
          </Typography>
          <Typography variant="body1" paragraph>
            Las cancelaciones podrán generar cargos dependiendo del momento en que se realicen.
            En caso de controversia, OneService podrá actuar como mediador, sin asumir responsabilidad directa por el resultado del servicio.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            7. Conductas Prohibidas
          </Typography>
          <Typography variant="body1" paragraph>
            Queda estrictamente prohibido:<br />
            · Utilizar la Plataforma para actividades ilícitas.<br />
            · Eludir el sistema de pagos.<br />
            · Hostigar o amenazar a otros usuarios.<br />
            · Publicar información falsa.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            8. Limitación de Responsabilidad
          </Typography>
          <Typography variant="body1" paragraph>
            OneService no garantiza:<br />
            · La calidad específica del servicio contratado.<br />
            · La disponibilidad ininterrumpida del sistema.<br />
            · La ausencia total de errores tecnológicos.
          </Typography>
          <Typography variant="body1" paragraph>
            La responsabilidad de OneService se limitará al máximo permitido por la legislación mexicana.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            9. Protección al Consumidor
          </Typography>
          <Typography variant="body1" paragraph>
            Cuando resulte aplicable, los servicios ofrecidos a través de la Plataforma se sujetarán a lo dispuesto por la Ley Federal de Protección al Consumidor (LFPC).
            Los usuarios podrán ejercer sus derechos ante las autoridades competentes.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            10. Resolución de Controversias
          </Typography>
          <Typography variant="body1" paragraph>
            Cualquier controversia derivada del uso de la Plataforma será resuelta preferentemente mediante:<br />
            1. Negociación directa.<br />
            2. Mediación.<br />
            3. Arbitraje administrado conforme a la legislación mexicana.
          </Typography>
          <Typography variant="body1" paragraph>
            En caso de no someterse a arbitraje, serán competentes los tribunales de la Ciudad de México, renunciando a cualquier otro fuero.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            11. Modificaciones
          </Typography>
          <Typography variant="body1" paragraph>
            OneService podrá modificar estas Condiciones en cualquier momento. El uso continuo implica aceptación.
          </Typography>
        </Box>

      </Container>
      <Footer />
    </>
  );
};

export default CondicionesUso;
